import React from "react";
import { useTranslation } from "react-i18next";
import ArchFlowContainer from "./archFlow/ArchFlowContainer";
import "./ArchitectureDiagram.scss";

const ArchitectureDiagram = () => {
  const { t } = useTranslation();

  return (
    <div className="hsv-arch-diagram">
      <ArchFlowContainer />
    </div>
  );
};

export default ArchitectureDiagram;
